import * as Mutations from "./mutation-types"
import * as Actions from "./action-types"
import * as api from "@/api/api"
import * as Helpers from "@/helpers"
import { Tabs } from "@/constants/appConstants"
import _ from "lodash";

const defaultProgramsQuery = {
    type: "ProgramQueryModel",
    start_date: "",
    end_date: "",
    pub_start_date: "",
    pub_end_date: "",
    searchForPubDate: false,
    with_wildcards: true,
    provider_keys: [],
    start_time_tv: "",
    countryTargetGroups: [],
    show_all_content_with_traffic_in_period: false,
    genres: {
        genre_keys: [],
        genres: [],
    },
    filterByRating: false,
    target_group: [],
    weekdays: [],
}
const defaultProgramsRoFQuery = {
    contentKeys: [],
    measureType: "absolute",
    aggregationType: "cumulative",
    maxFreq: 10,
    targetGroup: null,
    hasAdjustedTime: false,
}

const state = {
    queryCost: {
        data: null,
        isLoading: false,
        error: null,
    },
    programsInitStatus: "NOT_LOADED",
    programsQuery: _.cloneDeep(defaultProgramsQuery),
    programsQueryDefault: _.cloneDeep(defaultProgramsQuery),
    programsRoFMaxFreqOptions: [
        ...Array.from(new Array(20).keys()).map(idx => ({
            text: `${idx + 1}`,
            value: idx + 1,
        })),
    ],
    programsRoFQuery: {
        ...defaultProgramsRoFQuery,
    },
    programsQueryForAPI: {},
    programsExportQuery: {
        include_detail_rows: true,
        include_header: true,
    },
    programsResults: {
        status: "NOT_LOADED",
    },
    programsRoFResults: {
        status: "NOT_LOADED",
    },
    programsHaveSelectedRow: false,
    programsColumnTypes: [],
    programsDefaultColumns: [],
    programsAllWithStarSelected: true,
    programsWeekdayNumbers: [],
    programsProviders: [],
    programsQueryBeforeChange: {},
    programsStringForFilterBeforeChange: "",
    programsHasExcludedRow: false,
    programsSumVisible: false,
    programsHasSetDefaultQuery: false,
}

const convertFromQueryToQueryForAPI = (q, showConsumtionPeriodProgram) => {
    let minAfterMidnight = ""
    if(q.start_time_tv) {
        minAfterMidnight = Helpers.toMinutesAfterMidnight(q.start_time_tv.split("-"))
    }
    const defaultProgramsQueryForAPI = {
        type: "ProgramQueryModel",
        columns: [],
        measures: [],
        provider_keys: q.provider_keys,
        content_keys: q.content_keys ?? null,
        genres: q.genres,
        with_wildcard: q.with_wildcards,
        search_text: q.title,
        start_time_tv: minAfterMidnight,
        filterByRating: q.filterByRating,        
        weekday_numbers: q.weekdays,
        countryTargetGroups: q.countryTargetGroups
    }

    const APIQuery = {
        ...defaultProgramsQueryForAPI,
        start_date: q.start_date ?? null,
        end_date: showConsumtionPeriodProgram ? q.end_date : q.start_date,
        pub_start_date: q.searchForPubDate ? q.pub_start_date : null,
        pub_end_date: q.searchForPubDate ? q.pub_end_date : null,
        showPubDate: q.searchForPubDate,
        measures: q.target_group ? q.target_group : [],
        columns: q.columns ? q.columns : [],
        show_all_content_with_traffic_in_period: q.show_all_content_with_traffic_in_period,
    }
    return APIQuery
}

// helper function to execute program query
const executeQuery = async (context, query) => {
    // update queryForAPI to make debugging easier
    context.commit(Mutations.setProgramsQueryForAPI, query)
    try {
        var r = await api.executeProgramsQuery(query)
        // got a response
        // check if we got any rows
        if (r.programs.length == 0) {
            context.commit(Mutations.setProgramsResults, {
                status: "EMPTY_RESULT",
            })
        } else {
            let levelOneProgramsWithLevelTwoPrograms = r.programs
                .filter(p => p.contentGroupTotal && !p.isTotal)
                .map((p, i) => {
                    for (let i = 0; i < p.measures.length; i++) {
                        if (p.measures[i].trim().length == 0) {
                            p[`measure_${i + 1}`] = "0"
                        } else {
                            p[`measure_${i + 1}`] = p.measures[i]
                        }
                    }
                    let levelTwoPrograms = r.programs
                        .filter(lv2p => lv2p.groupKey === p.groupKey && !lv2p.contentGroupTotal)
                        .map(p => {
                            for (let i = 0; i < p.measures.length; i++) {
                                if (p.measures[i].trim().length == 0) {
                                    p[`measure_${i + 1}`] = "0"
                                } else {
                                    p[`measure_${i + 1}`] = p.measures[i]
                                }
                            }
                            return {
                                ...p,
                                chosen: false,
                            }
                        })
                    Helpers.setLevelOneValuesForPrograms(p, levelTwoPrograms, query.columns)
                    return {
                        ...p,
                        levelTwoPrograms: levelTwoPrograms,
                        index: i,
                        chosen: false,
                    }
                })
            let fields = context.getters.getProgramsColumnTypes
                .filter(c => query.columns.includes(c.value))
                .map(c => {
                    return {
                        key: c.value,
                        label: c.text,
                        sortable: true,
                        isMeasure: false,
                    }
                })
            const storedTargetGroups = query.measures
            let fieldsMeasures = []
            for (let i = 0; i < r.measureHeaders.length; i++) {
                let storedTargetGroup = storedTargetGroups.find(st => st.selectedMeasureText.subHeader == r.measureHeaders[i].subHeader)
                fieldsMeasures.push({
                    key: `measure_${i + 1}`,
                    label: `${r.measureHeaders[i].header} ${r.measureHeaders[i].subHeader}`,
                    header: r.measureHeaders[i].header,
                    subHeader: r.measureHeaders[i].subHeader,
                    sortable: true,
                    tdClass: "measureTdClass",
                    thClass: "measurethclass",
                    isMeasure: true,
                    source: storedTargetGroup.source,
                })
            }

            context.commit(Mutations.setProgramsResults, {
                status: "LOADED",
                data: {
                    levelOneProgramsWithLevelTwoPrograms: levelOneProgramsWithLevelTwoPrograms,
                    columns: [...fields, ...fieldsMeasures],
                    summary: r.summary,
                },
            })
        }
    } catch (error) {
        context.commit(Mutations.setProgramsResults, {
            status: "FAILED",
            data: null,
            error: error,
        })
    }
}
const setInitialTableColumns = async context => {
    let roFQuery = context.getters.getProgramsRoFQuery
    const maxNbrFreq = Math.min(context.getters.getProgramsRoFQuery.maxFreq, context.getters.getProgramsRoFResults.data.frequencyMatrix.length)
    let freq_array = []
    for (let idx = 0; idx < maxNbrFreq; idx++) {
        if (context.getters.getProgramsRoFResults.data.isCumulative)
            freq_array.push({
                key: `F${idx + 1}`,
                label: `F${idx + 1}+`,
                thClass: "text-right fwidth",
                tdClass: "text-right",
            })
        else
            freq_array.push({
                key: `F${idx + 1}`,
                label: `F${idx + 1}`,
                thClass: "text-right fwidth",
                tdClass: "text-right",
            })
    }
    let initialTableColumns = [
        {
            key: "channelNames",
            label: "Channel names",
            tdClass: "smallfontsize",
            thClass: "channelnamerofth",
        },
        {
            key: "titlecode",
            label: "Title code",
            tdClass: "smallfontsize",
            thClass: "titlecoderofth",
        },
        {
            key: `targetGroup`,
            label: `Target group`,
            tdClass: "text-right w100",
            thClass: "text-left targetgroupheaderwidth",
        },
        {
            key: `universalNumber`,
            label: `Universe`,
            thClass: "text-left universeheaderwidth",
            tdClass: "text-right w100",
        },
        {
            key: `reach_1_plus_acc`,
            label: roFQuery.measureType === "absolute" ? "Net Reach 1+ 000s" : "Net Reach 1+ %",
            thClass: "text-right rofreachheaderwidth",
            tdClass: "text-right",
        },
        // and average frequency
        {
            key: `average_frquency`,
            label: `Avg Freq`,
            thClass: "text-right rofavgfreqheaderwidth",
            tdClass: "text-right",
        },
        // and rating
        {
            key: `rating`,
            label: roFQuery.measureType === "absolute" ? "Rating 000s" : "Rating %",
            thClass: "text-right rofratingheaderwidth",
            tdClass: "text-right",
        },
        // and then the frequencies
        ...freq_array,
    ]
    context.commit(Mutations.setProgramsRoFResultsTableData, {
        ...context.getters.getProgramsRoFResults.tableData,
        initialTableColumns: initialTableColumns,
    })
}
const setInitialTableItem = async context => {
    let rofData = context.getters.getProgramsRoFResults.data
    const reach_1_plus_acc = rofData.reach1PlusAcc.map(x => ({
        reach_1_plus_acc: x,
    }))
    const average_frquency = rofData.averageFrequency.map(x => ({
        average_frquency: x,
    }))
    const rating = rofData.rating.map(x => ({
        rating: x,
    }))
    let highestFreq = Math.max(...context.getters.getProgramsRoFMaxFreqOptions.map(o => o.value))
    let firstChannelNames = Helpers.takeElementsUpTo200Chars(
        [
            ...new Set(
                context.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                    .filter(p => p.chosen)
                    .map(p => p.levelTwoPrograms)
                    .flat()
                    .map(p => p.providerName)
            ),
        ].sort()
    )
    let firstTitleCodes = Helpers.takeElementsUpTo200Chars([...context.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms.filter(p => p.chosen).map(p => p.titleCode)])
    let targetGroup = context.getters.getProgramsRoFQuery.targetGroup

    let initialTableItem = [rofData.frequencyMatrix.slice(-1)[0]].map(row => {
        let slotIdx = rofData.frequencyMatrix.length - 1
        const freqRow = row.slice(0, highestFreq).reduce(
            (prev, cur, freqIdx) => ({
                ...prev,

                // show no value on row/frequency that cannot have any value
                [`F${freqIdx + 1}`]: freqIdx > slotIdx ? null : cur,
            }),
            {}
        )
        let universalNumber = rofData.universalNumber
        return {
            channelNames: [...firstChannelNames].join(", "),
            titlecode: [...firstTitleCodes].join(", "),
            targetGroup: targetGroup,
            universalNumber: universalNumber,
            ...freqRow,
            ...reach_1_plus_acc[slotIdx],
            ...average_frquency[slotIdx],
            ...rating[slotIdx],
        }
    })
    context.commit(Mutations.setProgramsRoFResultsTableData, {
        ...context.getters.getProgramsRoFResults.tableData,
        initialTableItem: initialTableItem,
    })
}
const setRoFColumns = context => {
    let roFQuery = context.getters.getProgramsRoFQuery
    const maxNbrFreq = Math.min(roFQuery.maxFreq, context.getters.getProgramsRoFResults.data.frequencyMatrix.length)
    let freq_array = []
    for (let idx = 0; idx < maxNbrFreq; idx++) {
        if (context.getters.getProgramsRoFResults.data.isCumulative)
            freq_array.push({
                key: `F${idx + 1}`,
                label: `F${idx + 1}+`,
                thClass: "text-right fwidth",
                tdClass: "text-right",
            })
        else
            freq_array.push({
                key: `F${idx + 1}`,
                label: `F${idx + 1}`,
                thClass: "text-right fwidth",
                tdClass: "text-right",
            })
    }
    let roFColumns = [
        {
            key: `date`,
            label: "Consumption day",
        },
        {
            key: `reach_1_plus_acc`,
            label: roFQuery.measureType === "absolute" ? "Net Reach 1+ 000s" : "Net Reach 1+ %",
            thClass: "text-right rofreachheaderwidth",
            tdClass: "text-right",
        },
        // and average frequency
        {
            key: `average_frquency`,
            label: `Avg Freq`,
            thClass: "text-right rofavgfreqheaderwidth",
            tdClass: "text-right",
        },
        // and rating
        {
            key: `rating`,
            label: roFQuery.measureType === "absolute" ? "Rating 000s" : "Rating %",
            thClass: "text-right rofratingheaderwidth",
            tdClass: "text-right",
        },
        // and then the frequencies
        ...freq_array,
    ]
    context.commit(Mutations.setProgramsRoFResultsTableData, {
        ...context.getters.getProgramsRoFResults.tableData,
        roFColumns: roFColumns,
    })
}
const setAllRofRows = context => {
    const reach_1_plus_acc = context.getters.getProgramsRoFResults.data.reach1PlusAcc.map(x => ({
        reach_1_plus_acc: x,
    }))
    const average_frquency = context.getters.getProgramsRoFResults.data.averageFrequency.map(x => ({
        average_frquency: x,
    }))
    const rating = context.getters.getProgramsRoFResults.data.rating.map(x => ({
        rating: x,
    }))
    const dates = context.getters.getProgramsRoFResults.data.dates
    let highestFreq = Math.max(...context.getters.getProgramsRoFMaxFreqOptions.map(o => o.value))
    let allRofRows = context.getters.getProgramsRoFResults.data.frequencyMatrix.map((row, id) => {
        const freqRow = row.slice(0, highestFreq).reduce(
            (prev, cur, freqIdx) => ({
                ...prev,

                // show no value on row/frequency that cannot have any value
                [`F${freqIdx + 1}`]: freqIdx > id ? null : cur,
            }),
            {}
        )
        return {
            date: dates[id],
            ...freqRow,
            ...reach_1_plus_acc[id],
            ...average_frquency[id],
            ...rating[id],
        }
    })
    context.commit(Mutations.setProgramsRoFResultsTableData, {
        ...context.getters.getProgramsRoFResults.tableData,
        allRofRows: allRofRows,
    })
}

const actions = {
    // get all data required to display the page
    // update state programInitStatus to be able to have spinners etc during loading

    [Actions.getProgramsColumnTypes]: async () => {
        return await api.getColumnTypes("PROGRAMS")
    },
    [Actions.getProgramsMeasures]: async () => {
        return await api.getMeasures("PROGRAMS")
    },
    [Actions.getProgramsProviders]: async () => {
        return await api.getProviders(Tabs.ProgramTab)
    },
    [Actions.getProgramsGenres]: async () => {
        return await api.getGenres()
    },

    // this initializes the table and query, so use when pressing 'Search'
    [Actions.executeProgramsQuery]: async (context, showConsumtionPeriodProgram) => {
        context.commit(Mutations.setProgramsResults, {
            status: "LOADING",
            data: null,
        })

        // prepare query
        const query = convertFromQueryToQueryForAPI(context.state.programsQuery, showConsumtionPeriodProgram)

        // check if the query is OK to run and return to the interface, otherwise set queryCost so we handle it from there
        context.commit(Mutations.setQueryCostLoading, true)
        context.commit(Mutations.setQueryCostError, null)

        try {
            const queryCostData = await api.getQueryCostPrograms(query)
            await context.commit(Mutations.setQueryCostData, queryCostData)
        } catch (error) {
            await context.commit(Mutations.setQueryCostError, error)
        } finally {
            await context.commit(Mutations.setQueryCostLoading, false)
        }

        if (context.state.queryCost.error == null && context.state.queryCost.data.queryClass == "Normal") {
            await context.commit(Mutations.setProgramsQueryForAPI, query)
            query.lastPubDate = context.getters.getPublishedToDate
            await executeQuery(context, query)
        } else {
            context.commit(Mutations.setProgramsResults, {
                status: "NOT_LOADING",
                data: null,
            })
        }
    },

    [Actions.executeScheduleQuery]: async (context, options) => {
        const query = convertFromQueryToQueryForAPI(context.state.programsQuery, options.showConsumtionPeriodProgram)
        await context.commit(Mutations.setProgramsQueryForAPI, query)
        const apiQuery = {
            ...context.state.programsQueryForAPI,
            content_keys: options.programs,
        }
        apiQuery.end_date = options.showConsumtionPeriodProgram ? apiQuery.end_date : apiQuery.start_date
        apiQuery.include_detail_rows = context.state.programsExportQuery.include_detail_rows
        apiQuery.include_header = context.state.programsExportQuery.include_header

        if (apiQuery.include_header) {
            apiQuery.headeritems = Helpers.getHeaderProgramTab(context, "Program, list tab", apiQuery)
        }
        await api.createScheduledReportQuery(options.reportname, apiQuery)
    },

    //initializes csv-export request for program summary, use when pressing 'Export'
    [Actions.executeExportProgramsQuery]: async (context, options) => {
        let apiQuery = {}
        if (options.slowQueryModal) apiQuery = convertFromQueryToQueryForAPI(context.state.programsQuery, options.showConsumtionPeriodProgram)
        else
            apiQuery = {
                ...context.state.programsQueryForAPI,
                content_keys: options.programs,
            }
        apiQuery.end_date = options.showConsumtionPeriodProgram ? apiQuery.end_date : apiQuery.start_date
        apiQuery.include_detail_rows = context.state.programsExportQuery.include_detail_rows
        apiQuery.include_header = context.state.programsExportQuery.include_header
        apiQuery.sortBy = context.state.programsExportQuery.sortBy
        apiQuery.sortByDesc = context.state.programsExportQuery.sortByDesc

        if (apiQuery.include_header) {
            apiQuery.headeritems = Helpers.getHeaderProgramTab(context, "Program, list tab", apiQuery)
        }
        return await api.executeExportProgramsQuery(apiQuery)
    },
    [Actions.executeProgramsRoFQuery]: async context => {
        try {
            context.commit(Mutations.setProgramsRoFResults, {
                status: "LOADING",
                data: null,
            })
            let hasAdjustedTime = context.getters.getProgramsRoFQuery.hasAdjustedTime
            context.commit(Mutations.setProgramsRoFQuery, {
                ...context.getters.getProgramsRoFQuery,
                startDate: context.getters.getProgramsQueryForAPI.start_date,
                endDate: hasAdjustedTime ? context.getters.getProgramsRoFQuery.endDate : context.getters.getProgramsQuery.end_date,
            })
            let rofQuery = {
                ...context.getters.getProgramsRoFQuery,
                contentKeys: context.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                    .map(p => p.levelTwoPrograms)
                    .flat()
                    .filter(p => p.chosen)
                    .map(p => p.contentKey),
            }
            var r = await api.executeProgramsRoFQuery(rofQuery)
            const formatFunc = function(val) {
                return context.getters.getProgramsRoFQuery.measureType == "absolute" ? Math.round(val / 1000, 0).toLocaleString("sv-Sv") : `${Math.round(val * 1000) / 10}`
            }

            context.commit(Mutations.setProgramsRoFResults, {
                status: "LOADED",
                data: {
                    ...r,
                    frequencyMatrix: r.frequencyMatrix.map(row => row.map(cell => formatFunc(cell))),
                    reach1PlusAcc: r.reach1PlusAcc.map(cell => formatFunc(cell)),
                    averageFrequency: r.averageFrequency,
                    rating: r.rating.map(cell => formatFunc(cell)),
                },
                tableData: {
                    initialTableColumns: [],
                    initialTableItem: [],
                    roFColumns: [],
                    allRofRows: [],
                },
            })
            setInitialTableColumns(context)
            setInitialTableItem(context)
            setRoFColumns(context)
            setAllRofRows(context)
        } catch (error) {
            context.commit(Mutations.setProgramsRoFResults, {
                status: "FAILED",
                data: null,
                error: error,
            })
        }
    },
    [Actions.executeProgramsRoFExport]: async context => {
        try {
            let programsRoFQuery = context.getters.getProgramsRoFQuery
            let rofTableData = {
                ...context.getters.getProgramsRoFResults.tableData,
            }
            const rofTableDataCopy = JSON.parse(JSON.stringify(rofTableData))
            const initialTableColumns = rofTableDataCopy.initialTableColumns.map(obj => obj.label).join(";")
            rofTableDataCopy.initialTableItem[0].channelNames = [
                ...new Set(
                    context.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                        .filter(p => p.chosen)
                        .map(p => p.levelTwoPrograms)
                        .flat()
                        .map(p => p.providerName)
                ),
            ]
                .sort()
                .join(", ")
            rofTableDataCopy.initialTableItem[0].titlecode = context.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                .filter(p => p.chosen)
                .map(p => p.titleCode)
                .join(", ")
            const initialTableItem = rofTableDataCopy.initialTableItem
                .map(row => {
                    let csvInitialRowData = []
                    for (const column of rofTableDataCopy.initialTableColumns) {
                        csvInitialRowData.push(row[column.key])
                    }
                    return csvInitialRowData.join(";")
                })
                .join("\n")
            let csvContent = `${initialTableColumns}\n${initialTableItem}`
            csvContent += `\n\n${rofTableDataCopy.roFColumns.map(obj => obj.label).join(";")}`
            for (const row of rofTableDataCopy.allRofRows) {
                let csvAllRofRowsData = []
                for (const column of rofTableDataCopy.roFColumns) {
                    csvAllRofRowsData.push(row[column.key] ?? "")
                }
                csvContent += `\n${csvAllRofRowsData.join(";")}`
            }
            let fileName = `${context.getters.getExcelExportFilePreName} CROSS-PLATFORM_ProgramRoF_${programsRoFQuery.startDate}_${programsRoFQuery.endDate}.csv`
            Helpers.downloadBlob(csvContent, fileName, "text/csv;charset=utf-8;")
        } catch (error) {
            console.error(error)
        }
    },
}

const getters = {
    getProgramsQuery: state => state.programsQuery,
    getProgramsQueryDefault: state => state.programsQueryDefault,
    getProgramsHasSetDefaultQuery: state => state.programsHasSetDefaultQuery,
    getProgramsRoFQuery: state => state.programsRoFQuery,
    getProgramsQueryProviders: state => state.programsQuery.provider_keys,
    getProgramsRoFMaxFreqOptions: state => state.programsRoFMaxFreqOptions,
    getProgramsResults: state => state.programsResults,
    getProgramsHaveSelectedRow: state => state.programsHaveSelectedRow,
    getProgramsQueryForAPI: state => state.programsQueryForAPI,
    getProgramsExportQuery: state => state.programsExportQuery,
    getProgramsRoFResults: state => state.programsRoFResults,
    getTabIndex: state => state.tabIndex,
    getProgramsColumnTypes: ({ programsColumnTypes }) => programsColumnTypes,
    getProgramsProviders: state => state.programsProviders,
    getProgramsInitStatus: ({ programsInitStatus }) => programsInitStatus,
    getProgramsDefaultColumns: state => state.programsDefaultColumns,
    getProgramsAllWithStarSelected: state => state.programsAllWithStarSelected,
    getProgramsQueryCost: state => state.queryCost,
    getProgramsQueryBeforeChange: state => state.programsQueryBeforeChange,
    getProgramsStringForFilterBeforeChange: state => state.programsStringForFilterBeforeChange,
    getProgramsHasExcludedRow: state => state.programsHasExcludedRow,
    getProgramsSumVisible: state => state.programsSumVisible,
}

const mutations = {
    [Mutations.setProgramsQuery]: (state, payload) => (state.programsQuery = payload),
    [Mutations.setProgramsQueryDefault]: (state, payload) => (state.programsQueryDefault = payload),
    [Mutations.setProgramsRoFQuery]: (state, payload) => (state.programsRoFQuery = payload),
    [Mutations.setProgramsQueryProviders]: (state, payload) => (state.programsQuery.provider_keys = payload),
    [Mutations.setProgramsResults]: (state, payload) => (state.programsResults = payload),
    [Mutations.setProgramsHaveSelectedRow]: (state, payload) => (state.programsHaveSelectedRow = payload),
    [Mutations.setProgramsColumnTypes]: (state, payload) => (state.programsColumnTypes = payload),
    [Mutations.setProgramsInitStatus]: (state, payload) => (state.programsInitStatus = payload),
    [Mutations.setProgramsQueryForAPI]: (state, payload) => (state.programsQueryForAPI = payload),
    [Mutations.setProgramsExportQuery]: (state, payload) => (state.programsExportQuery = payload),
    [Mutations.setProgramsRoFResults]: (state, payload) => (state.programsRoFResults = payload),
    [Mutations.setProgramsRoFResultsTableData]: (state, payload) => (state.programsRoFResults.tableData = payload),
    [Mutations.setProgramsChannels]: (state, payload) => (state.programsChannels = payload),
    [Mutations.setProgramsProviders]: (state, payload) => (state.programsProviders = payload),
    [Mutations.setProgramsStartdate]: (state, payload) => (state.programsQuery.start_date = payload),
    [Mutations.setProgramsEnddate]: (state, payload) => (state.programsQuery.end_date = payload),
    [Mutations.setProgramsPubStartdate]: (state, payload) => (state.programsQuery.pub_start_date = payload),
    [Mutations.setProgramsPubEnddate]: (state, payload) => (state.programsQuery.pub_end_date = payload),
    [Mutations.setProgramsSearchForPubDate]: (state, payload) => (state.programsQuery.searchForPubDate = payload),
    [Mutations.setProgramsGenres]: (state, payload) => (state.programsGenres = payload),
    [Mutations.setProgramsDefaultColumns]: (state, payload) => (state.programsDefaultColumns = payload),
    [Mutations.setProgramsAllWithStarSelected]: (state, payload) => (state.programsAllWithStarSelected = payload),
    [Mutations.setProgramsWeekdays]: (state, payload) => (state.programsWeekdayNumbers = payload),
    [Mutations.setQueryCostData]: (state, payload) => (state.queryCost.data = payload),
    [Mutations.setQueryCostLoading]: (state, payload) => (state.queryCost.loading = payload),
    [Mutations.setQueryCostError]: (state, payload) => (state.queryCost.error = payload),
    [Mutations.setProgramsQueryBeforeChange]: (state, payload) => (state.programsQueryBeforeChange = payload),
    [Mutations.setProgramsStringForFilterBeforeChange]: (state, payload) => (state.programsStringForFilterBeforeChange = payload),
    [Mutations.setProgramsHasExcludedRow]: (state, payload) => (state.programsHasExcludedRow = payload),
    [Mutations.setProgramsSumVisible]: (state, payload) => (state.programsSumVisible = payload),
    [Mutations.setProgramsHasSetDefaultQuery]: (state, payload) => (state.programsHasSetDefaultQuery = payload),
}

export default {
    state,
    getters,
    mutations,
    actions,
}
